<template>
    <span>{{ value }} <span
        class="openBacklogChangesCell"
        :class="getBacklogChangesClass"
    >{{ formattedOpenBacklogChanges }}</span></span>
</template>

<script lang="ts">

export default {
    props: ['params'],
    computed: {
        value() {
            if (this.params.value) {
                return  this.params.value;
            }
            return '';
        },
        formattedOpenBacklogChanges() {
            const rowData = this.params.data; // Access the entire row's data
            if (rowData?.openCountChanges) {
                return  (rowData.openCountChanges > 0 ? '+' : '') + rowData.openCountChanges;
            }
            return '';
        },
        getBacklogChangesClass() {
            const rowData = this.params.data; // Access the entire row's data
            if (rowData?.openCountChanges && rowData.openCountChanges > 0) {
                return 'is-pos';
            }
            return 'is-neg';
        }
    }
};
</script>

<style lang="scss">

// Positive mean (backlog is growing) red. negative (backlog is declining) is good
.openBacklogChangesCell.is-pos { color: var(--color-status-negative); }
.openBacklogChangesCell.is-neg { color: var(--color-status-positive); }
.openBacklogChangesCell.is-zero { color: var(--color-status-neutral); }

</style>